module.exports = __webpack_public_path__ + "static/media/screen_2.4236ddfc.png";